import { AlertCircle } from "lucide-react";

const NoDataFound = ({ message = "No data found.", height = "200px", isEnroll=false, className='' }) => {
  return (
    <div
      className={`w-100 d-flex flex-column justify-content-center align-items-center text-muted ${className} ${isEnroll && 'bg-light rounded-4'}`}
      style={{ minHeight: height }}
    >
      <AlertCircle size={40} className="mb-2" />
      <p className="mb-0">{message}</p>
    </div>
  );
};

export default NoDataFound;
